import { Button, Modal } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PurchaseOrderItemForm } from "../PurchaseOrderItemForm";

export interface AddPurchaseOrderItemModalProps {
  purchaseOrderId: string;
  vendorId: string;
}

export const AddPurchaseOrderItemModal = ({
  purchaseOrderId,
  vendorId,
}: AddPurchaseOrderItemModalProps) => {
  const { t } = useTranslation();

  const [opened, setOpened] = useState(false);

  return (
    <>
      <Modal
        size="lg"
        opened={opened}
        centered
        onClose={() => setOpened(false)}
        title={t("ADD_ARTICLE")}
        closeOnClickOutside={false}
        overlayProps={{
          color: "white",
          opacity: 0.55,
          blur: 3,
        }}
      >
        <PurchaseOrderItemForm
          purchaseOrderId={purchaseOrderId}
          vendorId={vendorId}
        />
      </Modal>
      <Button onClick={() => setOpened(true)}>{t("ADD_ARTICLE")}</Button>
    </>
  );
};
